import { ApiResponse } from "@defs/api-response";
import { IWhiteLabelData } from "@defs/white-label";
import httpClient from "@http/client";

class WhiteLabelService {
  private url = `/white-label`;

  async get(): Promise<ApiResponse<IWhiteLabelData>> {
    const response = await httpClient.get<ApiResponse<IWhiteLabelData>>(
      this.url,
    );
    return response.data;
  }
}

const whiteLabelService = new WhiteLabelService();
export default whiteLabelService;
